// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import queryString from 'query-string';
import createHistory from 'history/createBrowserHistory';
import configureStore from './store/configureStore';
import environment from './environment';
import analytics from './analytics';
/* Containers and static Components to bind to routes */
import LocaleContainer from './modules/locale/containers/LocaleContainer';
import App from './App';
import logo from './assets/img/logoq-primary.png';

import type { RootState } from './modules';
import type { Country } from './entities';

const history = createHistory();
const initialStateKey = '__INITIAL_STATE__';
let initialState: RootState = ({}: any);

// Initial State
if (process.env.NODE_ENV === 'production' && window) {
  initialState = window[initialStateKey];
}

window.loadUrlInfo = () => {
  window.localStorage.removeItem('userReferrer');
  window.localStorage.removeItem('landingUrl');
  window.localStorage.removeItem('landingUTM');
  window.localStorage.setItem('userReferrer', document.referrer);
  window.localStorage.setItem('landingUrl', document.location.href);
  const parsedSearch = queryString.parse(location.search);
  const utmProperties: { [key: string]: string } = {
    utm_campaign: parsedSearch.utm_campaign || '',
    utm_source: parsedSearch.utm_source || '',
    utm_medium: parsedSearch.utm_medium || '',
  };
  if (parsedSearch.utm_term) utmProperties.utm_term = parsedSearch.utm_term;
  if (parsedSearch.utm_content) utmProperties.utm_content = parsedSearch.utm_content;
  window.localStorage.setItem('landingUTM', JSON.stringify(utmProperties));
};

// Store valuable url information
window.loadUrlInfo();

if (process.env.NODE_ENV === 'production' || process.env.WEBAPP_ENV === 'production') {
  // Load this fucking shitty coded script just in production
  const loadCollectChat = (w: any, d: any) => {
    w.CollectId = '5cf607330b6bc630b84ce444';
    var h = d.head || d.getElementsByTagName('head')[0];
    var s = d.createElement('script');
    s.setAttribute('type', 'text/javascript');
    s.setAttribute('src', 'https://collectcdn.com/launcher.js');
    h.appendChild(s);
  };
  loadCollectChat(window, document);
}

if (process.env.WEBAPP_ENV === 'production' && !!environment.notifia) {
  const loadNotifia = (d: any, s: any, i: any) => {
    var j = d.createElement('script');
    j.async = true;
    j.id = 'notifia';
    j.src = 'https://static.notifia.io/widget.js';
    j.setAttribute('initialize',i);
    d.head.appendChild(j);
  };
  loadNotifia(document, 'script', environment.notifia);
}

// Load Sirena Gadget
const loadSirenaGadget = (country: Country) => {
  const s = document.createElement('script');
  s.async = true;
  if (country === 'CO') {
    s.src = 'https://widget.sirena.app/get?token=916831276c044b4e8c840b342586c64c';
  } else if (country === 'PE') {
    s.src = 'https://widget.sirena.app/get?token=0ac4696fcbfb4bc798cf785a77914c81';
  }
  const h = document.head || document.getElementsByTagName('head')[0];
  h.appendChild(s);
};

window.loadSirenaGadget = loadSirenaGadget;

// Load bluesnap
const loadBlueSnap = () => {
  const blueSnapScript = document.createElement('script');
  blueSnapScript.src = environment.blueSnapLib;
  blueSnapScript.async = true;
  const sx: any = document.getElementsByTagName('script')[0];
  sx.parentNode.insertBefore(blueSnapScript, sx);

  blueSnapScript.onload = () => {
    console.log('BlueSnap loaded');
  };

  blueSnapScript.onerror = () => {
    console.log('BlueSnap could not be loaded, trying back up plan ...');

    const blueSnapBackupScript = document.createElement('script');
    blueSnapBackupScript.src = environment.blueSnapBackupLib;
    blueSnapBackupScript.async = true;
    // We need to load it after the bluesnap script because the bluesnap.js reads from the tag!! wtf!
    const sx: any = document.querySelector('script[src*=\'bluesnap.js\']');
    sx.parentNode.insertBefore(blueSnapBackupScript, sx.nextSibling);

    blueSnapBackupScript.onload = () => console.log('BlueSnap loaded');

    blueSnapBackupScript.onerror = () => console.log('BlueSnap could not be loaded');
  };
};

if (document.readyState === 'complete')
  loadBlueSnap();
else if (window.addEventListener)
  window.addEventListener('load', loadBlueSnap, false);
else if (window.attachEvent) {
  window.attachEvent('onload', loadBlueSnap);
}

// Print logo
// if (process.env.NODE_ENV !== 'production') {
// $FlowIgnoreLine: logo is a custom function implemented on polyfill just for printing logo
console.logo(logo, `v${environment.version} [${environment.env}]`);
//}

// Initial State check for authenticated users to initialize
// Sentry context
// analytics.afterInitialStateParsedBeforeApplicationHook(initialState);

const store = configureStore(initialState, history);

const BrowserApp = () => (
  <Provider store={store}>
    <LocaleContainer>
      <ConnectedRouter history={history}>
        <App history={history}/>
      </ConnectedRouter>
    </LocaleContainer>
  </Provider>
);

export default BrowserApp;



// WEBPACK FOOTER //
// ./src/BrowserApp.jsx